import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class MasivoService {
    constructor(http) {
        this.http = http;
    }
    cargarMasivos(formData) {
        const headers = new HttpHeaders({
            'Access-Control-Allow-Origin': '*'
        });
        return this.http.post(`${environment.API_REST_URL}/uploadFileMasivo`, formData, { headers });
    }
}
MasivoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MasivoService_Factory() { return new MasivoService(i0.ɵɵinject(i1.HttpClient)); }, token: MasivoService, providedIn: "root" });
